import { BaseStore } from '@cgs/shared';
import { Container } from '@cgs/wge';
import { SOUND_STORAGE_STRATEGY_TOKEN, SoundStorageStrategy } from './sound-storage.strategy';

export const SOUND_STORE_TOKEN = Symbol('SoundStore');

export interface SoundStoreState {
  backgroundMusic: boolean;
  soundFX: boolean;
}

export class SoundStore extends BaseStore<SoundStoreState> {
  constructor(private readonly container: Container) {
    super({ backgroundMusic: false, soundFX: false });

    const savedSound = this.getSavedSound();

    if (savedSound) {
      this.state = savedSound;
    }

    this.stream.on((state) => {
      this.saveSound(state);
    });
  }

  protected saveSound(state: SoundStoreState): void {
    const storageStrategy = this.container.resolve<SoundStorageStrategy>(
      SOUND_STORAGE_STRATEGY_TOKEN
    );
    storageStrategy.save(state);
  }

  protected getSavedSound(): SoundStoreState | null {
    const storageStrategy = this.container.resolve<SoundStorageStrategy>(
      SOUND_STORAGE_STRATEGY_TOKEN
    );
    return storageStrategy.getSaved();
  }
}
